import { Text } from "@chakra-ui/react";
import type { FlagTextProps } from "./FlagText.d";

const FlagText = ({ text }: FlagTextProps) => (
  <Text textTransform="uppercase" fontSize="sm" fontWeight="bold" color="greyscale.600" letterSpacing="1px">
    {text}
  </Text>
);

export default FlagText;
